var exports = {
  "o": "xfd349460--3eb4fd--underground-icon",
  "F": "xfd349460--3eb4fd--underground-icon--regions",
};

module.exports = exports;
